$(document).on('turbolinks:load', function () {
  $('[data-visible-checkbox]').each(function () {
    var $checkbox = $(this).find('[type="checkbox"]');
    var $container = $(this).find('[data-content]');

    if ($checkbox.prop('checked')) {
      $container.show()
    } else {
      $container.hide()
    }

    $checkbox.change(function () {
      if ($checkbox.prop('checked')) {
        $container.show()
      } else {
        $container.hide()
      }
    });
  });
  // init multi select
  $('.multiple').selectpicker();
});
